import styled from "@emotion/styled";
import { Stack } from "@mui/material";

const StackContainer = styled(Stack)`
  width: 100%;
`;

const Heading = styled.p`
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  margin-block: 0px;
  padding-block: 0px;
  letter-spacing: 0px;

  @media (max-width: 600px) {
    font-size: 10px;
  }
`;

const Description = styled.span`
  font-size: 12px;

  @media (max-width: 600px) {
    font-size: 8px;
  }
`;

const SC = {
  StackContainer,
  Heading,
  Description,
};

export default SC;
